<template>
  <div class="account-manage">
    <div class="header">
      <img src="/Logo.png" alt="Logo" class="logo" />
      <h2>账号管理</h2>
    </div>

    <div class="content">
      <!-- 搜索和操作栏 -->
      <el-card class="search-section">
        <el-form :inline="true" size="small">

          <el-form-item>
            <el-input v-model="searchQuery" placeholder="搜索用户名/账号" prefix-icon="el-icon-search" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAdd">添加账号</el-button>
            <!-- <el-button type="danger" @click="handleBatchDelete" :disabled="!selectedAccounts.length">
              批量删除
            </el-button> -->
            <el-button @click="$router.push('/HelloWorld')">返回</el-button>
          </el-form-item>
          
        </el-form>
        <el-form inline>
          <!-- 根据游戏名搜索账号 -->
          <el-form-item>
            <el-input v-model="searchGameName" placeholder="搜索游戏名" prefix-icon="el-icon-search" clearable ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearchGameName">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 账号列表 -->
      <el-card class="account-table" v-loading="isLoading">
        <el-table :data="accounts" style="width: 100%" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column prop="username" label="用户名" min-width="120"></el-table-column>
          <el-table-column prop="role" label="角色" min-width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.role === 0 ? 'danger' : 'success'">
                {{ scope.row.role === 0 ? '管理员' : '普通用户' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" min-width="180">
            <template slot-scope="scope">
              {{ formatDate(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column prop="updatedAt" label="最后更新时间" min-width="180">
            <template slot-scope="scope">
              {{ formatDate(scope.row.updatedAt) }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="140">
            <template slot-scope="scope">
              <div class="status-wrapper">
                <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="1"
                  :inactive-value="0" @change="(val) => handleStatusChange(val, scope.row)" :disabled="isLoading"
                  transition />
                <span class="status-text">{{ scope.row.status === 1 ? '启用' : '禁用' }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="handleEdit(scope.row)" icon="el-icon-view">查看游戏</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 添加/编辑账号对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="accountForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!accountForm.accountId">
          <el-input v-model="accountForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "../api/http";

export default {
  name: "AccountManage",
  data() {
    return {
      searchQuery: "",
      searchGameName: "",
      isLoading: false,
      accounts: [],
      filteredAccounts: [],
      selectedAccounts: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      dialogVisible: false,
      dialogTitle: "添加账号",
      accountForm: {
        accountId: null,
        username: "",
        password: "",
        role: 1,
        status: 1
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        role: [
          { required: true, message: "请选择角色", trigger: "change" }
        ]
      }
    };
  },
  // 所有方法必须放在 methods 内部
  methods: {
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const rawDate = String(dateString);
      const match = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/);
      if (!match) return rawDate;
      return `${match[1]}-${match[2]}-${match[3]} ${match[4]}:${match[5]}:${match[6]}`;
    },

    // 获取账号列表
    fetchAccounts() {
      this.isLoading = true;
      http.get("/api/user/getAllUserAndGame", {
        params: {
          pageCurrent: this.currentPage,
          pageSize: this.pageSize
        },
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          // console.log(res.data.data.records);
          this.accounts = res.data.data.records;
          this.total = res.data.data.total;
          // this.handleSearch();
        } else {
          this.$message.error(res.data.msg || "获取账号列表失败");
        }
      }).catch(() => {
        // console.error("Error:", error);
        this.$message.error("获取账号列表失败");
      }).finally(() => {
        this.isLoading = false;
      });
    },

    handleSearch() {
      this.isLoading = true;
      http.get("/api/user/search", {
        params: {
          username: this.searchQuery,
        },
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.accounts = res.data.data;
          this.total = res.data.data.total;
        } else {
          this.$message.error(res.data.msg || "获取账号列表失败");
        }
      }).catch(() => {
        this.$message.error("搜索失败，请稍后重试");
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handleSearchGameName() {
      this.isLoading = true;
      http.get("/api/userGames/selectAccount", {
        params: {
          gameName: this.searchGameName,
        },
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.accounts = res.data.data;
          this.total = res.data.data.total;
        } else {
          this.$message.error(res.data.msg || "获取账号列表失败");
        }
      }).catch(() => {
        this.$message.error("搜索失败，请稍后重试");
      }).finally(() => {
        this.isLoading = false;
      });
    },

  // 添加账号
  handleAdd() {
    this.dialogTitle = "添加账号";
    this.accountForm = {
      accountId: null,
      username: "",
      password: "",
      role: 1,
      status: 1
    };
    this.dialogVisible = true;
  },

  // 编辑账号
  handleEdit(row) {
    this.$router.push(`/game-info/${row.username}`);
  },

  // 删除账号
  handleDelete(row) {
    this.$confirm(`确认删除${row.username}的账号吗？`, "提示", {
      type: "warning"
    }).then(() => {
      this.isLoading = true; // 开始加载
      http.delete(`/api/user/delete/${row.username}`, {
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.$message.success("删除成功");
          this.fetchAccounts();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      }).catch(error => {
        this.$message.error("删除失败：" + error);
      }).finally(() => {
        this.isLoading = false; // 结束加载
      });
    }).catch(() => { });
  },

  // 批量删除
  handleBatchDelete() {
    if (!this.selectedAccounts.length) return;

    this.$confirm(`确认删除选中的 ${this.selectedAccounts.length} 个账号吗？`, "提示", {
      type: "warning"
    }).then(() => {
      const ids = this.selectedAccounts.map(account => account.accountId);
      // 调用批量删除API
      http.post("/api/user/batchDelete", { ids }, {
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.$message.success("批量删除成功");
          this.fetchAccounts();
        } else {
          this.$message.error(res.data.msg || "批量删除失败");
        }
      });
    }).catch(() => { });
  },

  // 提交表单
  submitForm() {
    http.post("/api/user/register", this.accountForm, {
      headers: {
        "token": `${localStorage.getItem("token")}`
      }
    }).then(res => {
      // console.log(res);
      if (res.data.code === 1) {
        this.$message.success("添加成功");
        this.dialogVisible = false;
        this.fetchAccounts();
      } else {
        this.$message.error(res.data.msg || "添加失败");
      }
    })
  },

  // 状态改变
  handleStatusChange(newStatus, row) {
    const oldStatus = row.status;
    this.isLoading = true; // 显示加载状态

    // 1. 简单参数校验：确保 accountId 存在（根据实际接口需求调整）
    // const token = localStorage.getItem("token");
    // console.log('token:', token);
    if (!row.accountId) {
      this.$message.error("账号 ID 异常，无法更新状态");
      this.isLoading = false;
      return;
    }

    http.post("/api/user/updateStatus", {
      accountId: row.accountId,
      status: newStatus
    }, {
      headers: {
        "token": localStorage.getItem("token")
      }
    }).then(res => {
      // console.log(res)
      if (res.data.code === 1) {
        this.$message.success("状态更新成功");
        row.updatedAt = new Date().toISOString(); // 更新最后更新时间
      } else {
        // 2. 处理后端返回的业务错误（比如参数错误、权限不足等）
        this.$message.error(res.msg || "状态更新失败");
        // 回滚状态，保持前端显示和实际一致
        row.status = oldStatus;
      }
    }).catch(() => {
      // 3. 处理网络错误、500 等异常
      // console.error("更新状态请求失败：", error);
      this.$message.error("服务器异常，请稍后重试");
      // 回滚状态
      row.status = oldStatus;
    }).finally(() => {
      this.isLoading = false;
    });
  },

  // 选择改变
  handleSelectionChange(val) {
    this.selectedAccounts = val;
  },

  // 分页大小改变
  handleSizeChange(val) {
    this.pageSize = val;
    this.fetchAccounts();
  },

  // 当前页改变
  handleCurrentChange(val) {
    this.currentPage = val;
    this.fetchAccounts();
  }
},


mounted() {
  this.fetchAccounts();
}
};
</script>

<style scoped>
.account-manage {
  padding: 30px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f6f8fc 0%, #e9ecf4 100%);
}

.header {
  text-align: center;
  margin-bottom: 30px;
  animation: fadeInDown 0.5s ease-out;
}

.logo {
  height: 70px;
  margin-bottom: 15px;
  transition: transform 0.3s;
}

.logo:hover {
  transform: scale(1.05);
}

.header h2 {
  color: #2c3e50;
  font-size: 24px;
  margin: 0;
  font-weight: 500;
}

.content {
  animation: fadeIn 0.5s ease-out;
}

.search-section {
  margin-bottom: 20px;
  border-radius: 12px;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.search-section :deep(.el-card__body) {
  padding: 20px;
}

.account-table {
  border-radius: 12px;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.account-table :deep(.el-card__body) {
  padding: 20px;
}

.account-table :deep(.el-table) {
  border-radius: 8px;
  overflow: hidden;
}

.account-table :deep(.el-table th) {
  background-color: #f8fafc;
  color: #606266;
  font-weight: 600;
  padding: 12px 0;
}

.account-table :deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
  background-color: #f5f7fa;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .account-manage {
    padding: 15px;
  }

  .el-form-item {
    margin-bottom: 15px;
  }

  .search-section :deep(.el-form--inline .el-form-item) {
    display: block;
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
